import { Link } from "@mui/material";
import { forwardRef } from "react";
import { type LinkProps as RouterLinkProps } from "react-router-dom";

import { BaseLink } from "../BaseLink/Link";
import { type MuiLinkProps } from "../types";

export interface InternalLinkProps extends Omit<MuiLinkProps, "href"> {
  to: RouterLinkProps["to"];
}

/**
 * @deprecated Use the TextButton component from the ui-components package to show links instead.
 * Link redirection logic should be handled by the specific application that consumes this component.
 * Buttons in ui-components accept a LinkComponent prop which must be passed by the consuming application.
 */
export const InternalLink = forwardRef<HTMLAnchorElement, InternalLinkProps>((props, ref) => {
  return <Link ref={ref} component={BaseLink} {...props} />;
});

InternalLink.displayName = "InternalLink";
